import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'

export function getIbanBadgeColors(ibanDetailsFilled?: boolean, ibanExportedAt?: Date) {
  if (!ibanDetailsFilled)
    // No IBAN filled by staff
    return {
      color: tailwindColors.red.DEFAULT,
      bgColor: tailwindColors.red.light.DEFAULT
    }
  if (!ibanExportedAt)
    // IBAN filled but not downloaded by admin
    return {
      color: tailwindColors.orange.DEFAULT,
      bgColor: tailwindColors.orange.light.DEFAULT
    }

  // IBAN filled and downloaded by admin
  return {
    color: tailwindColors.green.DEFAULT,
    bgColor: tailwindColors.green.light.DEFAULT
  }
}
